import { render } from "./app-language-switcher.vue?vue&type=template&id=5b917520&ts=true"
import script from "./app-language-switcher.vue?vue&type=script&lang=ts"
export * from "./app-language-switcher.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__